import type { JsonApiResponse } from '~/interfaces/api/main';
import type { OpportunityConsents, UpdateConsentsPayload } from '~/interfaces/opportunities/identity/consents';
import { useAuthFetchNext } from '~/composables/useAuthFetch.next';
import { isAPIErrorResponse } from '~/composables/useUtils';
import { authMutate } from '~/composables/http/authMutate';
import { createApiError } from '~/api/utils';

export const getOpportunityConsents = async (
  opportunityReqId: number,
): Promise<OpportunityConsents | null> => {
  const response = await useAuthFetchNext(`opportunities/${opportunityReqId}/consents`);

  if (isAPIErrorResponse(response)) {
    console.error('[Consents]', response.errors);
    return null;
  }

  const payload = response as JsonApiResponse<OpportunityConsents>;
  return payload.data ?? null;
};

export const updatePersonConsents = async (
  opportunityHashId: string,
  personId: number,
  payload: UpdateConsentsPayload,
): Promise<void> => {
  const response = await authMutate(
    `opportunities/${opportunityHashId}/persons/${personId}/consents`,
    { method: 'PUT', body: payload, silentError: true },
  );

  if (isAPIErrorResponse(response)) {
    throw createApiError('Le consentement n\'a pas pu être enregistré', response.errors);
  }
};
